import { FC } from 'react';
import { ProductPageContent } from 'whitelabel-main-pages-content/product-page-content';
import { defaultProductServerSideProps } from 'whitelabel-main-pages-ssr';

interface ProductPageProps {
  params: {
    slug: string;
    filters?: string | null;
  };
}

export const ProductPage: FC<ProductPageProps> = ({ params }) => {
  return <ProductPageContent params={params} />;
};

export const getServerSideProps = defaultProductServerSideProps();

export default ProductPage;
